class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    // price range filter
    this.querySelector('form .range__field') && this.querySelector('form .range__field').addEventListener(
      'priceRange',
      this.debouncedOnSubmit.bind(this)
    );

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    // on refresh setup price range values
    let urlString = window.location.href,
      url = new URL(urlString),
      maxPrice = url.searchParams.get('filter.v.price.lte'),
      minPrice = url.searchParams.get('filter.v.price.gte');
    FacetFiltersForm.setUpPriceRange(minPrice, maxPrice);

    //[Addition] To update the filter count bubble
    const urlParams = window.location.search;
    const activeFiltersCount = FacetFiltersForm.getFilterCount(urlParams);
    FacetFiltersForm.updateFilterCount(activeFiltersCount);

    //sort close dropdown when click outside it or pick a sort option
    let temp_this = this;
    window.addEventListener('click', function (event) {
      if (temp_this.querySelector('#FacetSortDrawerForm details summary')
      && !temp_this.querySelector('#FacetSortDrawerForm details summary').contains(event.target)) {
        FacetFiltersForm.toggleSortDropdown(event, temp_this);
      }
    });

    //sort update
    FacetFiltersForm.updateSort();
  }

  static updateDutfitFilter() {
    let dutfitFilterElem = document.querySelector('.dufte_filter');
    if (dutfitFilterElem) {
      let filterCheckbox = dutfitFilterElem.querySelector('.dufte_checkbox');
      if(filterCheckbox)
        filterCheckbox.addEventListener('click', function () {
          if (filterCheckbox && filterCheckbox.checked) {
            updateCheckboxes(dutfitFilterElem, true)
          } else {
            updateCheckboxes(dutfitFilterElem, false)
          }
        })
    }
    setTimeout(() => {
      dutfitFilterElem.querySelector('.dufte_list_item') && dutfitFilterElem.querySelector('.dufte_list_item').classList.remove('mobile-facets__label--disabled', 'disabled');
    }, 800);
  }
  static updateCheckboxes(filterElem, isDufte) {
    if (isDufte) {
      filterElem.querySelector('.list-menu__item:not(.dufte_list_item) input.mobile-facets__checkbox[value="1"]').checked = true;
      filterElem.querySelector('.list-menu__item:not(.dufte_list_item) input.mobile-facets__checkbox[value="0"]').checked = false;
    } else {
      filterElem.querySelector('.list-menu__item:not(.dufte_list_item) input.mobile-facets__checkbox[value="1"]').checked = false;
      filterElem.querySelector('.list-menu__item:not(.dufte_list_item) input.mobile-facets__checkbox[value="0"]').checked = true;
    }
  }

  static toggleSortDropdown(evt, temp_this) {
    if (!evt.target.classList.contains('active-sortName')
    && temp_this.querySelector('.sort-items__button')) {
      temp_this.querySelector('.sort-items__button').removeAttribute('open');
    }
  }

  static updateSort() {
    let sortItems = document.querySelectorAll(
      '.sort-items__wrapper .sort-items__option'
    );

    if (sortItems) {
      sortItems.forEach((element) => {
        element.addEventListener('click', function (e) {
          var filterForm = document.querySelector('form#FacetFiltersFormMobile');
          //console.log(filterForm)
          filterForm.querySelector('[name="sort_by"]').value =
            element.dataset.value;
          filterForm.dispatchEvent(new Event('input', { bubbles: true }));
          //remove is active class
          sortItems.forEach((item) => {
            if (item.classList.contains('is-active')) {
              item.classList.remove('is-active');
            }
          });
          //add active to clicked item
          if (!element.classList.contains('is-active')) {
            element.classList.add('is-active');
            let selectedSortName = document.querySelector('.active-sortName');
            if (selectedSortName) {
              selectedSortName.innerHTML = element.innerHTML;
            }
          }
          if (
            document.querySelectorAll(
              `.sort-items__wrapper .sort-items__option[data-value="${element.dataset.value}"]`
            )
          ) {
            document
              .querySelectorAll(
                `.sort-items__wrapper .sort-items__option[data-value="${element.dataset.value}"]`
              )
              .forEach((item) => {
                if (!item.classList.contains('is-active')) {
                  item.classList.add('is-active');
                }
              });
          }
        });
      });
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static setUpPriceRange(minPrice, maxPrice) {
    let rangeSliderMobile = document.querySelector(
      '#range-slider-mobile'
    ),
      //      desktopRangeParent = document.getElementById('FacetFiltersForm'),
      mobileRangeParent = document.getElementById('FacetFiltersFormMobile');

    FacetFiltersForm.rangeSliderElementCreate(
      rangeSliderMobile,
      minPrice,
      maxPrice,
      mobileRangeParent
    );
  }

  static getFilterCount(searchParams) {
    if (searchParams == null) return 0;
    let counter = 0, paramValue = '';
    let params = searchParams.split('&');

    params.forEach(function (param) {
      if (param.includes('filter')) {
        paramValue = param.split('=');
        if (paramValue.length >= 2) {
          if (paramValue[1] != '' && paramValue[0] !== 'filter.v.price.lte') {
            counter++;
          }
        }
      }
    })
    return counter;
  }

  static updateFilterCount(activeParams) {
    let counterElems = document.querySelectorAll('.activeFilters-bubble');
    counterElems.forEach(function (counter) {
      counter.innerHTML = activeParams;
      if (activeParams <= 0)
        counter.classList.add('hidden');
      else
        counter.classList.remove('hidden');
    })
  }

  static rangeSliderElementCreate(selector, minPrice, maxPrice, parent) {
    let minValue = minPrice ? minPrice : window.priceRanges.min,
      maxValue = maxPrice ? maxPrice : window.priceRanges.max,
      minValueText = parent.querySelector('.range-min-value span'),
      maxValueText = parent.querySelector('.range-max-value span');
    if (minValueText) minValueText.innerHTML = minValue;
    if (maxValueText) maxValueText.innerHTML = maxValue;
    if (selector)
      rangeSlider(selector, {
        // min value
        min: window.priceRanges.min,
        // max value
        max: window.priceRanges.max,

        // step size
        step: 5,
        // initial values
        value: [minValue, maxValue],
        // disable the range slider element
        disabled: false,
        // disable the range slider
        rangeSlideDisabled: false,
        // disable left/right (top/bottom) thumbs
        thumbsDisabled: [false, false],
        // or 'vertical'
        orientation: 'horizontal',
        // callback function
        onInput: function (valueSet) {
          let numberS = parent.querySelectorAll('.range__field'),
            minValueText = parent.querySelector('.range-min-value span'),
            maxValueText = parent.querySelector('.range-max-value span');
          numberS[0].value = valueSet[0];
          numberS[1].value = valueSet[1];
          minValueText.innerHTML = valueSet[0];
          maxValueText.innerHTML = valueSet[1];
          numberS[0].dispatchEvent(new Event('priceRange'));
          numberS[1].dispatchEvent(new Event('priceRange'));
        },
      });
  }

  static renderPage(
    searchParams,
    event,
    updateURLHash = true,
    lowPrice = window.priceRanges.min,
    highPrice = window.priceRanges.max
  ) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    setTimeout(() => {
      FacetFiltersForm.setUpPriceRange(lowPrice, highPrice);
      let facetFormMobile = document.querySelector(
        'facet-filters-form.facet-filters-form-mobile'
      );

      facetFormMobile
        .querySelector('form .range__field') && facetFormMobile
        .querySelector('form .range__field').addEventListener(
          'priceRange',
          facetFormMobile.debouncedOnSubmit.bind(this)
        );
      FacetFiltersForm.updateSort();

      //[Addition] To update the filter count bubble
      let ActiveFilterCount = FacetFiltersForm.getFilterCount(searchParams);
      FacetFiltersForm.updateFilterCount(ActiveFilterCount);
      //[Addition] To update the filter count bubble

      //[Addition] Update Dufte filter
      FacetFiltersForm.updateDutfitFilter();
      //[Addition] Update Dufte filter
    }, 1500);
  }

  static renderSectionFromFetch(url, event, searchParams) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event, searchParams);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event, searchParams) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event, searchParams);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner');
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event, searchParams) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML, searchParams);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newElementSelector = document
          .getElementById(closestJSFilterID)
          .classList.contains('mobile-facets__details')
          ? `#${closestJSFilterID} .mobile-facets__close-button`
          : `#${closestJSFilterID} .facets__summary`;
        const newElementToActivate = document.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html, searchParams) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      //[Addition] To update the filter count bubble
      const activeFiltersCount = FacetFiltersForm.getFilterCount(searchParams);
      FacetFiltersForm.updateFilterCount(activeFiltersCount)
      //[Addition] To update the filter count bubble
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    // don't filter prices with the default price range.
    let urlString = window.location.href,
      url = new URL(urlString),
      maxPrice = url.searchParams.get('filter.v.price.lte'),
      minPrice = url.searchParams.get('filter.v.price.gte');
    //console.log(window.location.href)
    if (
      formData.get('filter.v.price.gte') == window.priceRanges.min &&
      formData.get('filter.v.price.lte') == window.priceRanges.max
    ) {
      if (minPrice != null && maxPrice != null) {
        formData.set('filter.v.price.gte', minPrice);
        formData.set('filter.v.price.lte', maxPrice);
      } else {
        formData.delete('filter.v.price.gte');
        formData.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams, event,
      true,
      formData.get('filter.v.price.gte'),
      formData.get('filter.v.price.lte'));
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
